import styled from "styled-components";
import { ReloadOutlined } from '@assets';
import { Button as AntButton,  } from "antd";

export const Container = styled.div`
	display: flex;
	align-items: center;
	box-sizing: border-box;
	gap: 8px;

	padding: 16px;
	border-radius: 15px;
	border: 2px solid var(--light-green, #00DE00);
	background: #FFF;
	box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10);
	width: 100%;

	@media screen and (max-width: 376px) {
		padding: 12px;
		gap: 4px;
	}

	@media screen and (max-width: 301px) {
		padding: 12px 4px;
	}
`;

export const ActionButton = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	padding: 0 30px;
	cursor: pointer;

	:first-child {
		flex: 1;
		padding: 0;
		flex-direction: row;
		gap: 4px;
	}

	@media screen and (max-width: 405px) {

		:first-child {
			padding: 0;
			gap: 0;
		}

		.ant-space {
			gap: 2px !important;
		}
	}

	@media screen and (max-width: 390px) {
		svg {
			width: 20px;
		}
	}
`;

export const BalanceText = styled.p`
	flex: 1;
	width: 100%;


	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	align-items: flex-start;

	text-align: left;
	padding: 0;
	position: relative;

	p{
		color: #1C1C1C;
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 22px; /* 183.333% */
	}

	@media screen and (max-width: 390px) {
		font-size: 10px;
	}

	@media screen and (max-width: 340px) {
		padding-left: 0;
	}

	@media screen and (max-width: 340px) {
		font-size: 9px;
	}
`;

export const ReloadIcon = styled(ReloadOutlined)`
margin-bottom: -2px;
`;

export const Amount = styled.div`
	color: #004E00;
	font-family: "Archivo";
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;

	@media screen and (max-width: 350px){
		font-size: 14px;
	}
`

export const Button = styled(AntButton)`
	height: 40px;
	border-radius: 15px;
	border: 2px solid var(--white, #FFF);
	background: var(--gradient-yellow, linear-gradient(180deg, #FFF970 0%, #E68A00 100%));
	box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25) inset;

	font-size: 12px;
	color: #006400;

	svg{
		width: 24px;
		height: 24px;
	}

	@media screen and (max-width: 390px){
		gap: 2px !important;
	}

	@media screen and (max-width: 360px){
		font-size: 11px;
		padding: 2px 4px;
		height: 35px;

		svg{
			width: 20px;
			height: 20px;
		}
	}
`;

export const ButtonLight = styled(AntButton)`
	height: 40px;
	border-radius: 15px;
	border: 2px solid var(--white, #FFF);
	background: linear-gradient(180deg, #00DE00 0%, #008500 97.5%, #008500 98.5%);
	box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.25) inset;

	font-size: 12px;
	color: #fff;

	svg{
		width: 24px;
		height: 24px;
	}

	@media screen and (max-width: 390px){
		gap: 2px !important;
	}

	@media screen and (max-width: 360px){
		font-size: 11px;
		padding: 2px 4px;
		height: 35px;

		svg{
			width: 20px;
			height: 20px;
		}
	}
`